import { render, staticRenderFns } from "./OrderDetailPage.vue?vue&type=template&id=1a79bc49&scoped=true"
import script from "./OrderDetailPage.vue?vue&type=script&lang=js"
export * from "./OrderDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a79bc49",
  null
  
)

export default component.exports